// Fix for browser extensions modifying DOM (Grammarly, translators, etc.)
// This MUST run before React loads to prevent "Failed to execute 'removeChild' on 'Node'" errors
(function() {
  if (typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function(child) {
      if (child && child.parentNode !== this) {
        console.warn('[DOM Patch] Cannot remove a child from a different parent');
        return child;
      }
      return originalRemoveChild.apply(this, arguments);
    };

    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function(newNode, referenceNode) {
      if (referenceNode && referenceNode.parentNode !== this) {
        console.warn('[DOM Patch] Cannot insert before a reference node from a different parent');
        return newNode;
      }
      return originalInsertBefore.apply(this, arguments);
    };
  }
})();

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Error Boundary component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error but don't crash the app for DOM-related errors
    if (error.message && error.message.includes('removeChild')) {
      console.warn('DOM manipulation error caught:', error.message);
      this.setState({ hasError: false }); // Try to recover
    } else {
      console.error('Application error:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h2>Une erreur est survenue</h2>
          <button onClick={() => window.location.reload()}>
            Recharger la page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
